import { formatWY } from '@/api/utils'
import { getLabelColor, filterStr } from '@/api/instrumentControl.js'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getOrgShowName } from "@/api/global.js";

export default {
  data () {
    return {
      lineClampMom: {}
    }
  },
  methods: {
    getImg (val, config) {
      if (!val) return ''
      const ind = (config.options || []).findIndex(it => it.value === val)

      if (ind !== -1) {
        return [config.options[ind].img || '']
      }
      return [val]
    },
    isAppenBtn(list, row) {
      let customData = []
      customData = this.$store.state.dashboardCustomDataObj[this.dashboardId] || []
      let rr = JSON.parse(JSON.stringify(row))
      const rInd = this.isPartition ? row.rowIndexNew : row.rowIndex
      rr = {...rr, ...this.config.user[rInd]}
      return isConditionAppen(list.condition, rr, true, customData) 
    },
    
    setRevise (it, list, scope, tableId) {
      // 全选修改的
      if (scope.row.isAll) {
        const dom = document.querySelector(`#${tableId}`)
        if (dom) {
          this.allCheck = it.name 
          const id = it.name + list.ind
          const arr = dom.querySelectorAll(`#${id}`)
          let index = 0
          for (const dom of arr) {
            if (index > 0) {
              dom.click()
            } 
            index++
          }
        }
      } else {
        const rInd = (this.isPartition ? scope.row.rowIndexNew : scope.row.rowIndex) - 1
        const label = list.ind
        const row = scope.row
        row[list.label] = row[list.ind]
        const sl = filterStr(list.label)
        const se = (list.ind || '').substring(0, list.ind.length - sl.length)
        this.$emit('setReviseRow', { key: label, rInd, sum: list.ind, sumL: se, row: row, value: it })
      }
    },
    rSetReviseRow (config) {
      this.$emit('rSetReviseRow', config)
    },
    getIsRevise (ind, len) {
      if (!this.config) return false
      // 如果当前条为汇总条，不显示
      if (this.config && this.config.isSummary && this.config.isSummary === 1 && this.config.tableData && ((this.config.tableData.length - 1) === len || this.oneInd)) return false
      const row = (this.config && this.config.row || []).map(it => it.name)
      if (this.config && this.config.upRevise && (row.length === 0 || !row.includes(ind))) return true
      return false
    },
    getColorSum (label, value) {
      if (this.summaryObj.colorConfig && this.summaryObj.colorConfig[label]) {
        const config = this.summaryObj.colorConfig[label]
        return getLabelColor(config, value, undefined, config.colorType)
      }
      return {}
    },
    getIconRight (width, key) {
      let w = 0
      const c = this.valueConfig || {}
      for (const i of this.formdatas) {
        if (i[key]) {
          const w1 = this.getWidthCanvas(i[key], (c.fontWeight + ' ' + c.fontSize + ' arial')) + 20
          if (w1 > w) w = w1
        }
      }
      return w > width
    },
    getWidthCanvas (str, font) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = font
      const metrics = context.measureText(str)
      return metrics.width
    },
    clampMom (key) {
      this.lineClampMom[key] = !this.lineClampMom[key]
    },
    getColorNumber (config, val) {
      if (!config || !val) return {}
      if (config.markedRed && val < 0) return { color: '#ff0000' }
      return {}
    },
    getFromNum (val, key, config) {
      if (config && (config.value === 'currency' && config.currency === '万元')) val = formatWY(val)
      if (key && !isNaN(Number(val))) val = this.numFormatFun(val)
      if (Array.isArray(val) && val[0] && (val[0].name ||val[0].realname)) {
        // 是组织或者联系人、角色
        val = val.map(item => {
          if (item && item.organizationId) {
           return getOrgShowName(item)
          } else {
            return item.name || item.realname
          }
        }).join()
      }
      return config && config.value && config.value === 'percentage' ? (val * 100).toFixed(config.decimal || 0) : val
    },
    // 数字格式设置
    numFormat ({config, key = 'left', numVal, isFormatNum}) {
      if (config && isFormatNum) {
        switch (key) {
          case 'color':
            return config.value && config.value !== 'percentage' && config.markedRed && Number(numVal) < 0 ? {color: '#ff0000'} : ''
          case 'left':
            return (config.value === 'currency' || config.value === 'accounting') && config.currency !== '万元' ? config.currency : ''
          case 'right':
            return config.value === 'number' && (config.customSymbols || config.customSymbols === 0) ? config.customSymbols : config.value === 'percentage' ? '%' : config.value === 'currency' &&  config.currency === '万元' ? config.currency : ''
        }
      }
    },
    numFormatFun(num){
      const res = num.toString().replace(/\d+/, function(n){ // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
          return $1+",";
        });
      })
      return res;
    },
    getColor (config, value) {
      if (value || value === 0) {
        return getLabelColor(config, value, undefined, config.colorType)
      }
      return ''
    }
  }
}
